<template>
    <div id="checkUser" class="position-relative">
        <div v-if="!status">
            <div class="h5 mb-28">Введите телефон</div>

            <div class="row align-items-end">
                <div class="mb-4 mb-sm-0 col-sm-6 col-lg-4">
                    <div class="input-box">
                        <label for="login" class="color-text-grey" :class="{'error-form': $v.login.$error}">Телефон*</label>
                        <input id="login" type="text"
                               placeholder="+"
                               @input="delayTouch($v.login)"
                               v-model.trim="login"
                               v-mask="'+################'">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте формат введенного номера.</div>
                            <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <button id="next_1" class="button btn-small" @click="checkUser()">Далее</button>
                </div>
                <div class="col-sm-12 col-lg-12 mt-4">
                    <div class="mb-32 checkbox" :class="{'error-form': $v.register_confirm_agree.$error}">
                        <input id="register_confirm_agree" type="checkbox"
                               @input="delayTouch($v.register_confirm_agree)"
                               v-model.trim="register_confirm_agree">
                        <label for="register_confirm_agree">Я даю согласие на <router-link to="/rules/obrabotka-personalnykh-dannykh " class="text-underline">обработку персональных данных</router-link></label>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="status == 2">
            <div class="h5 mb-28">
                У вас есть аккаунт. Для дальшейшего оформления введите пароль для входа в личный кабинет.
            </div>

            <div class="mb-28 row align-items-center">
                <div class="mb-4 mb-lg-0 col-sm-6 col-lg-4">
                    <div class="input-box">
                        <label for="login_phone" class="color-text-grey" :class="{'error-form': $v.login.$error}">Телефон*</label>
                        <input id="login_phone" type="text"
                               placeholder="+"
                               @input="delayTouch($v.login)"
                               v-model.trim="login"
                               v-mask="'+################'">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте формат введенного номера.</div>
                            <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="mb-4 mb-lg-0 col-sm-6 col-lg-4">
                    <div class="input-box">
                        <label for="login_pass" :class="{'error-form': $v.password.$error}">Пароль*</label>
                        <input id="login_pass" type="password"
                               @input="delayTouch($v.password)"
                               v-model.trim="password">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.required">Поле обязательно для заполнения.</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <button class="button btn-small" @click="loginUser()">Далее</button>
                </div>
            </div>

            <div class="h6 d-block pt-2 font-500">
                <router-link to="/reset">Забыли пароль? Перейдите на страницу восстановления.</router-link>
            </div>
        </div>
        <div v-if="status == 3">
            <div v-if="register_step_1">
                <div class="h5 mb-28">Введите код, который пришел на ваш номер телефона</div>
                <div class="row align-items-end">
                    <div class="col-sm-10 col-md-4 mb-4">
                        <div class="input-box">
                            <label for="register_phone" :class="{'error-form': $v.login.$error}">Телефон*</label>
                            <input id="register_phone" type="text"
                                   placeholder="+"
                                   @input="delayTouch($v.login)"
                                   v-model.trim="login"
                                   v-mask="'+################'">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте формат введенного номера.</div>
                                <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле обязательно для заполнения</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-10 col-md-4 mb-4">
                        <div class="input-box">
                            <label for="register_code" :class="{'error-form': $v.code.$error}">Код*</label>
                            <input id="register_code" type="text"
                                   @input="delayTouch($v.code)"
                                   v-model.trim="code">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.code.$error && !$v.code.required">Поле обязательно для заполнения</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-10 col-md-4">
                        <button class="button btn-small" @click="registerUser()" id="go">Продолжить</button>
                    </div>
                </div>

            </div>

            <div v-if="!register_step_1">

                <div class="h5 mb-28">Укажите кто Вы и придумайте пароль для своего личного кабинета, где будет отображаться информация о статусе вашего заказа.</div>

                <div class="row">
                    <div class="col-sm-10 col-lg-4 mb-4">
                        <div class="input-box">
                            <label>Выберите, кто Вы*</label>
                            <multiselect v-model="type"
                                         :options="type_options"
                                         selectedLabel=""
                                         selectLabel=""
                                         placeholder=""
                                         deselectLabel=""
                                         :allowEmpty="false"
                                         :searchable="false">
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-sm-10 col-lg-4 mb-4">
                        <div class="input-box">
                            <label for="card_fio" :class="{'error-form': $v.fio.$error}">
                                <span v-if="type === 'Физическое лицо'">ФИО*</span>
                                <span v-else>Наименование*</span>
                            </label>
                            <input id="card_fio" type="text"
                                   @input="delayTouch($v.fio)"
                                   v-model.trim="fio">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.fio.$error && !$v.fio.required">Поле обязательно для заполнения</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-10 col-lg-4 mb-4">
                        <div class="input-box">
                            <label for="card_email" :class="{'error-form': $v.email.$error}">
                                <span>E-mail*</span>
                            </label>
                            <input id="card_email" type="email"
                                   @input="delayTouch($v.email)"
                                   v-model.trim="email">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.email.$error && !$v.email.required">Поле обязательно для заполнения</div>
                                <div class="h6 pt-1 error-form" v-if="$v.email.$error && $v.email.required && !$v.email.email">Неверный формат</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-10 col-lg-4 mb-4">
                        <div class="input-box">
                            <label for="register_pass" :class="{'error-form': $v.password.$error}">Пароль*</label>
                            <input id="register_pass" type="password"
                                   @input="delayTouch($v.password)"
                                   v-model.trim="password">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.minLength">Пароль должен содержать не менее 8 знаков.</div>
                                <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.required">Поле обязательно для заполнения.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-10 col-lg-4 mb-4">
                        <div class="input-box">
                            <label for="register_pass_repeat" :class="{'error-form': $v.password_confirm.$error}">Повторить пароль*</label>
                            <input id="register_pass_repeat" type="password"
                                   @input="delayTouch($v.password_confirm)"
                                   v-model.trim="password_confirm">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.password_confirm.$error && !$v.password_confirm.minLength">Пароли не совпадают.</div>
                                <div class="h6 pt-1 error-form" v-if="$v.password_confirm.$error && !$v.password_confirm.required">Поле обязательно для заполнения.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-10 col-lg-4 mb-4">
                        <div class="input-box">
                            <label for="card_code">
                                <span>Код</span>
                            </label>
                            <input id="card_code" type="text"
                                   v-model.trim="ref_code">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-10 col-lg-4">
                        <button class="button btn-small" @click="registerUser()">Продолжить</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="loading-box">
            <b-spinner></b-spinner>
        </div>

    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {
        phoneRule,
        passwordRule,
        requiredRule,
        passwordRepeatRule,
        emailReqRule,
        checkbox
    } from '../../../../services/validation';
    const touchMap = new WeakMap();

    import order from '../../../../services/order'

    export default {
        components: { Multiselect },
        data() {
            return {
                order: order,

                clicks: 0,
                login: null,
                password: null,
                password_confirm: null,
                email: null,
                code: null,
                ref_code: null,
                type: 'Физическое лицо',
                fio: null,
                register_confirm_agree: false,

                status: null,
                register_step_1: true,

                type_options: [ 'Физическое лицо', 'Юридическое лицо' ],

                loading: false
            }
        },
        methods: {
            checkUser() {
                this.$v.$touch();
                this.$v.register_confirm_agree.$touch();
                if (this.$v.$invalid || this.$v.register_confirm_agree.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;

                    let url = '/api/register/check-user';

                    let params = {
                        phone: this.login,
                    };

                    axios.post(url, params)
                        .then(response => {
                            if(response.status == 200) {
                                if(response.data.success === 'success') this.status = 2;
                                else this.status = 3;
                                this.loading = false;
                            }
                        })
                        .catch(error => {
                           if(error) this.loading = false
                        })
                }
            },

            loginUser() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;

                    let url = '/api/login';
                    let params = {
                        phone: this.login,
                        password: this.password,
                    };

                    axios.post(url, params)
                        .then(response => {
                            if(response.status == 200) {
                                localStorage.setItem('token', response.data.access_token);
                                this.$store.dispatch('fetchUser');
                                this.order.state.step = 2;
                                this.loading = false

                            }
                        })
                        .catch(error => {
                            if(error) this.loading = false
                        })
                }
            },

            register(bonuses) {
                let url = '/api/register/register-account';
                let params = {
                    phone: this.login,
                    password: this.password,
                    password_confirm: this.password_confirm,
                    type: this.type,
                    fio: this.fio,
                    email: this.email,
                    ref_code: this.ref_code,
                };
                axios.post(url, params)
                    .then(response => {
                        if(response.status == 200) {
                            localStorage.setItem('token', response.data.access_token);
                            this.$store.dispatch('fetchUser');
                            this.order.state.step = 2;

                            this.loading = false
                        }
                    })
                    .catch(error => {
                        if(error) this.loading = false
                    })
            },

            registerUser() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    if(!this.register_step_1) {
                        this.clicks += 1;
                        if (this.clicks === 1) {
                            this.loading = true;
                            axios.post('/api/ref-code-value', { ref_code: this.ref_code })
                                .then(response => {
                                    this.register(response.data.bonuses);
                                })
                                .catch(error => {
                                    this.register(100);
                                })
                        }
                    }
                    if(this.register_step_1) {
                        this.loading = true;

                        let url = '/api/register/check-pin';
                        let params = {
                            phone: this.login,
                            pin: this.code
                        };
                        axios.post(url, params)
                            .then(response => {
                                if(response.status == 200) {
                                   this.register_step_1 = false;
                                    this.loading = false;
                                }
                            })
                            .catch(error => {
                                if(error) this.loading = false
                            })
                    }

                }
            },

            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            }
        },

        validations() {
            if(!this.status) {
                return {
                    login: phoneRule,
                    register_confirm_agree: checkbox
                }
            }

            if(this.status == 2) {
                return {
                    login: phoneRule,
                    password: requiredRule
                }
            }

            if(this.status == 3 && this.register_step_1) {
                return {
                    login: phoneRule,
                    code: requiredRule,
                }
            }

            if(this.status == 3 && !this.register_step_1) {
                return {
                    password: passwordRule,
                    password_confirm: passwordRepeatRule,
                    type: requiredRule,
                    fio: requiredRule,
                    email: emailReqRule,
                }
            }

        }
    }
</script>
